import React from 'react';

export default function Footer() {
  const year = new Date().getFullYear();

  const handleNav = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer
      style={{
        background: '#1a1a2e',
        color: 'rgba(254, 253, 248, 0.85)',
        padding: '2.5rem 1rem 1.5rem',
        marginTop: '2rem',
      }}
    >
      <div
        style={{
          maxWidth: '64rem',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem',
        }}
      >
        <div>
          <p
            style={{
              fontFamily: 'Caveat, serif',
              fontSize: '1.65rem',
              fontWeight: 700,
              color: '#fefdf8',
              marginBottom: '0.5rem',
            }}
          >
            🧮 Etsy Fee Calculator
          </p>
          <p
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.93rem',
              lineHeight: 1.6,
              color: 'rgba(254, 253, 248, 0.82)',
            }}
          >
            See exactly what you keep on every Etsy sale — across 61 countries,
            with all 2026 fees built in.
          </p>
        </div>

        <div>
          <h4
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#fefdf8',
              marginBottom: '0.75rem',
            }}
          >
            Calculator
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            {[
              ['home', 'Home'],
              ['articles', 'Guides'],
              ['faq', 'FAQ'],
              ['contact', 'Contact'],
            ].map(([id, label]) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  onClick={(e) => handleNav(e, id)}
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.93rem',
                    color: 'rgba(254, 253, 248, 0.86)',
                    textDecoration: 'none',
                  }}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#fefdf8',
              marginBottom: '0.75rem',
            }}
          >
            Resources
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            <li>
              <a
                href="https://help.etsy.com/hc/en-us/articles/115014483627"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.93rem',
                  color: 'rgba(254, 253, 248, 0.86)',
                  textDecoration: 'none',
                }}
              >
                Etsy's Official Fee Schedule ↗
              </a>
            </li>
            <li>
              <a
                href="https://help.etsy.com/hc/en-us/articles/1500011073202"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.93rem',
                  color: 'rgba(254, 253, 248, 0.86)',
                  textDecoration: 'none',
                }}
              >
                Regulatory Operating Fees ↗
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        style={{
          maxWidth: '64rem',
          margin: '0 auto',
          paddingTop: '1.5rem',
          borderTop: '1px solid rgba(254, 253, 248, 0.1)',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1rem',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.86rem',
            color: 'rgba(254, 253, 248, 0.86)',
            margin: 0,
          }}
        >
          © {year} Etsy Fee Calculator · Independent tool · Not affiliated with Etsy, Inc.
        </p>
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.88rem',
            color: 'rgba(254, 253, 248, 0.62)',
            margin: 0,
          }}
        >
          ✓ Fee data verified Apr 2026
        </p>
      </div>
    </footer>
  );
}
